import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, Checkbox, Container, Form, FormField, Input, Multiselect, SpaceBetween, TimeInput } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { parse } from 'date-fns';
import DPModal from '../../../../components/DPModal';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { weekDays } from '../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../commons/functions';

export const MarketingProgramEditPage = () => {
    //const storeAdmin = useStoreAdmin();
    const [stage, setStage] = useState("A")

    const { navigate } = useRouter();
    const { menu, data } = useGlobalState();

    const [program, setProgram] = useState<any>(null)
    const [medias, setMedias] = useState<any[]>([])



    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");
            if (id)
                handleGetProgram(parseInt(id));
            else {
                setProgram(null);
            }
        };

        window.addEventListener("hashchange", handleHashChange);
        handleHashChange();

        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);

    const handleGetProgram = async (idMedia: number) => {

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/marketing/programs/get',
                },
                body: JSON.stringify({
                    idMedia: idMedia
                }),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                const airportTime = parse(dataWeb.dateAirport, "dd-MM-yyyy", new Date());

                /*
                console.log(dataWeb.program)
                const dataMap = dataWeb.program.map((program: any) => {
                    return {
                        ...program,
                        hasEnded: program.jsonSchedule.endDate === ""
                            || parse(program.jsonSchedule.endDate, "dd-MM-yyyy", new Date()) > airportTime
                            ? 0 : 1,
                        hasStarted: program.jsonSchedule.startDate === ""
                            || parse(program.jsonSchedule.startDate, "dd-MM-yyyy", new Date()) < airportTime
                            ? 1 : 0,
                    };

                });
                console.log(dataMap)
                */
                setProgram(dataWeb.program);
                setMedias(dataWeb.medias);
            } else {
                addNotification(dataWeb.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {

    }, []);
    const handleUpdateProgram = async () => {

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/marketing/programs/update',
                },
                body: JSON.stringify(program),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                addNotification(dataWeb.status, 'success', setData);
                setProgram(null);
                window.location.href = "#marketing/programs"

            } else {
                addNotification(dataWeb.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            setLoading(false)
        }
    };
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                program !== null && (
                    <SpaceBetween size="s">
                        <Header variant="h1" actions={<Button variant="link" onClick={() => { setProgram(null); window.location.href = "#marketing/programs" }}>Volver</Button>}></Header>
                        <Form actions={<Button variant="primary" onClick={() => {
                            handleUpdateProgram();
                        }}>Guardar</Button>}>
                            <SpaceBetween size="s" direction='vertical'>
                                <Container header={<Header variant='h2'>Información general</Header>}>
                                    Programa <strong>{program.program ? `${program.program}` : `#${program.idMedia}`}</strong> se encuentra <strong>{program.isActive === 1 ? "activo" : "inactivo"}</strong>. {program.jsonSchedule.startDate !== "" ? `Su fecha de inicialización es el ${program.jsonSchedule.startDate}${program.jsonSchedule.startTime !== "" ? ` a las ${<strong>program.jsonSchedule.startTime</strong>}` : ""}` : <strong>"No tiene fecha de inicio establecida"</strong>}. {program.jsonSchedule.endDate !== "" ? `Su fecha de término es el ${program.jsonSchedule.endDate}${program.jsonSchedule.endTime !== "" ? ` a las ${program.jsonSchedule.endTime}` : ""}` : "No tiene fecha de término establecida"}. Actualmente se encuentra {program.hasStarted === 1 ? "en exposición" : "pendiente de inicio"}. {program.hasEnded === 1 ? "Ha finalizado su periodo de exposición." : "No ha finalizado su periodo de exposición."}. Será publicado en {program.jsonDisplays.length} display(s) y cuenta con {program.jsonMediaSets.length} medio(s) asignados. {program.jsonSchedule.weekDays.length < 7 && weekDays.length > 0 ? `Se expondrá los días ${program.jsonSchedule.weekDays.map((wd: number) => weekDays.find((d) => d.weekDay === wd)?.label).join(", ")}.` : "Se expondrá sin restricción de día semanal."}
                                </Container>
                                <FormField label="Nombre del programa" constraintText="Opcional">
                                    <Input value={program.program} onChange={(e) => setProgram({ ...program, program: e.detail.value })} />
                                </FormField>
                                <FormField label="Activo" constraintText="">
                                    <Checkbox checked={program.isActive === 1} onChange={(e) => setProgram({ ...program, isActive: e.detail.checked ? 1 : 0 })}>
                                        Programa se despliega en los displays asignados
                                    </Checkbox>
                                </FormField>
                                <Container header={<Header variant='h2'>Inicio</Header>}>
                                    <SpaceBetween size="s" direction='horizontal'>
                                        <FormField label="Fecha">
                                            <DPModal date={program.jsonSchedule.startDate} onConfirm={(date: string) => setProgram({ ...program, jsonSchedule: { ...program.jsonSchedule, startDate: date } })} />
                                        </FormField>
                                        <FormField label="Hora">
                                            <TimeInput autoComplete={false} name={"startTime"} format="hh:mm" value={program.jsonSchedule.startTime} onChange={(e) => setProgram({ ...program, jsonSchedule: { ...program.jsonSchedule, startTime: e.detail.value } })} />
                                        </FormField>
                                    </SpaceBetween>
                                </Container>
                                <Container header={<Header variant='h2'>Término</Header>}>
                                    <SpaceBetween size="s" direction='horizontal'>
                                        <FormField label="Fecha">
                                            <DPModal date={program.jsonSchedule.endDate} onConfirm={(date: string) => setProgram({ ...program, jsonSchedule: { ...program.jsonSchedule, endDate: date } })} />
                                        </FormField>
                                        <FormField label="Hora">
                                            <TimeInput autoComplete={false} name={"endTime"} format="hh:mm" value={program.jsonSchedule.endTime} onChange={(e) => setProgram({ ...program, jsonSchedule: { ...program.jsonSchedule, endTime: e.detail.value } })} />
                                        </FormField>
                                    </SpaceBetween>
                                </Container>
                                <Container header={<Header variant='h2'>Exposición</Header>}>
                                    <SpaceBetween size="s" direction='horizontal'>
                                        {weekDays.filter((day) => day.weekDay !== 0).map((day) => (
                                            <Checkbox checked={program.jsonSchedule.weekDays.includes(day.weekDay)} onChange={(e) => {
                                                let newWeekDays = [...program.jsonSchedule.weekDays];
                                                if (e.detail.checked) {
                                                    newWeekDays.push(day.weekDay);
                                                }
                                                else {
                                                    newWeekDays = newWeekDays.filter((wd) => wd !== day.weekDay);
                                                }
                                                setProgram({ ...program, jsonSchedule: { ...program.jsonSchedule, weekDays: newWeekDays } });
                                            }} >{day.label}</Checkbox>
                                        ))}
                                    </SpaceBetween>
                                </Container>
                                <Container header={<Header variant='h2'>Displays</Header>}>
                                    <Multiselect
                                        filteringType='auto'
                                        options={data.displays.map((display: any) => ({ label: display.display, value: display.idDisplay.toString() }))}

                                        selectedOptions={
                                            program.jsonDisplays.map((idDisplay: number) => {
                                                const display = data.displays.find((d: any) => d.idDisplay === idDisplay);
                                                return display ? { label: display.display, value: display.idDisplay.toString() } : null;
                                            }).filter((opt: any) => opt !== null)
                                        }
                                        onChange={(e) => {
                                            const selectedIds = e.detail.selectedOptions.map((opt) => parseInt(opt.value || "0"));
                                            setProgram({ ...program, jsonDisplays: selectedIds });

                                        }}


                                    />
                                </Container>
                                {medias && (
                                    <Container header={<Header variant='h2'>Medios</Header>}>
                                        <Multiselect
                                            filteringType='auto'
                                            options={medias
                                                .map((medium: any) => ({
                                                    label: medium.fileName,
                                                    value: medium.idMediaSet.toString(),
                                                    description: `${Math.round(medium.metadata.size)}KB; A/R: ${medium.metadata.aspect}; Dim: ${medium.metadata.width}x${medium.metadata.height}`
                                                }))
                                                .sort((a, b) => {
                                                    // Check if 'a' and 'b' are in the current program selection
                                                    const aSelected = program.jsonMediaSets.includes(parseInt(a.value));
                                                    const bSelected = program.jsonMediaSets.includes(parseInt(b.value));
                                                    if (aSelected && !bSelected) return -1;
                                                    if (!aSelected && bSelected) return 1;
                                                    return 0;
                                                })
                                            }
                                            selectedOptions={
                                                program.jsonMediaSets.map((idMediaSet: number) => {
                                                    const medium = medias.find((m: any) => m.idMediaSet === idMediaSet);
                                                    return medium ? { label: medium.fileName, value: medium.idMediaSet.toString() } : null;
                                                }).filter((opt: any) => opt !== null)
                                            }
                                            onChange={(e) => {
                                                const selectedIds = e.detail.selectedOptions.map((opt) => parseInt(opt.value || "0"));
                                                setProgram({ ...program, jsonMediaSets: selectedIds });
                                            }}
                                        />
                                    </Container>
                                )}

                            </SpaceBetween>
                        </Form>

                    </SpaceBetween>
                )
            }
        />
    )
};
